<template>
	<div class="summary-confirm text-center">
		<h2 style="padding-left: 0">¡Hemos recibido tu pedido!</h2>
		<p class="text-center">Muchas gracias por comprar en Lasddi.com. Recibirás el resumen de tu pedido por correo electrónico.
		<br><br>
		</p>
		<p class="text-bold text-center">
			Tu número de pedido es: <span class="text-bold-bg">{{ render_payment_id }}</span>
			<br><br>
		</p>
		<p class="text-center">
			Por cualquier consulta que tengas referente a tu pedido puedes consultarnos por correo a cuentas@lasddi.com o telefónicamente al (33) 2748 2493.<br><br>
		</p>
		<!-- <div class="col-sm-4 no-padding-sides">
			<button class="btn btn-black btn-lg" style="width: 80%;">Ver pedido</button>
		</div> -->
			<br><br>
	</div>
</template>

<script>
export default {
	computed: {
		render_payment_id() {
			return this.$route.query.paymentID;
		}
	}
}
</script>



// WEBPACK FOOTER //
// Shopping-cart-confirm.vue?5fc3d439